<template>
  <vue-dropzone :id="$attrs.id" ref="filesList" class="files-list" :options="filesListOptions" />
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';

export default {
  name: 'BaseDropzone',

  components: {
    vueDropzone: vue2Dropzone
  },

  props: {
    files: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      filesListOptions: {
        url: 'https://httpbin.org/post',
        addRemoveLinks: true,
        init: () => {
          setTimeout(() => {
            if (this.files.length) {
              this.files.forEach((item) => {
                const { id, size, name, ext, url } = item;
                const file = { size, name, type: ext, id };
                this.$refs.filesList.manuallyAddFile(file, url);
              });
            }
          }, 0);
        }
      }
    };
  }
};
</script>

<style lang="scss" scoped>
::v-deep .dz-preview {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border-bottom: 1px solid #eeeff8;
}
::v-deep .dz-preview:hover {
  background-color: #f4f5fd;
  border: 0px solid transparent;
  border-radius: 10px;
}
::v-deep .dz-message {
  margin-bottom: 10px;
  display: none; // hide dropzone
}
::v-deep .dz-error-message {
  display: none;
}
::v-deep .dz-success-mark {
  display: none;
}
::v-deep .dz-error-mark {
  display: none;
}
::v-deep .dz-details {
  display: flex;
}
::v-deep .dz-size {
  display: none;
}
::v-deep .dz-image {
  display: none;
}
::v-deep .dz-filename {
  color: #7a7b97;
}
::v-deep .dz-filename::before {
  font-family: 'FontAwesome';
  content: '\f15b';
  margin: 0 10px;
  color: #3c44b1 !important;
  font-size: 18px;
}
::v-deep .dz-remove {
  visibility: hidden;
  position: relative;
}
::v-deep .dz-remove::after {
  font-family: 'FontAwesome';
  color: #f83245 !important;
  visibility: visible;
  margin-right: 10px;
  font-size: 18px;
  content: '\f00d';
  display: none; // hide remove icon
}
::v-deep .dz-remove:hover::after {
  font-family: 'FontAwesome';
  color: #f3939d !important;
}
.progress-bar__video {
  background-color: #28a745;
}
</style>
